<template>
  <div id="pageTable">
    <v-container grid-list-xl fluid>
      <v-flex class="text-xs-right mb-4">
        <v-btn color="blue" dark small fab @click="refresh()">
          <v-icon>refresh</v-icon>
        </v-btn>
      </v-flex>

      <v-flex xs12 md6 lg4>
        <v-form ref="formTemplate" v-model="valid" lazy-validation>
          <v-card>
            <v-card-title>
              <h4 style="float:left">Фильтр</h4>
            </v-card-title>

            <v-divider></v-divider>

            <v-card-text class="pa-3">
              <v-switch v-model="poh2022" label="POH 2022"></v-switch>

              <v-autocomplete label="Отчет" :items="reportList" @change="changeReport($event)"
                :rules="[rules.required]"></v-autocomplete>

              <v-autocomplete label="Сотрудник" :items="staffListForSelect"
                @change="changeStaff($event)"></v-autocomplete>

              <v-text-field @click="filter.modalOpen = true" :value="filter.value.start + '—' + filter.value.end"
                :label="filter.name" :prepend-icon="filter.icon" append-icon="close" @click:append="clearDateFilter()"
                readonly :rules="[rules.dateEmpty]"></v-text-field>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn depressed :disabled="disableBtnSave" color="primary" @click="getReport()">Скачать
                <v-icon right dark>save</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>

          <!-- Период. Модальное окно -->
          <v-dialog v-model="filter.modalOpen" full-width width="290px">
            <v-date-picker v-model="dateRange" color="green" :first-day-of-week="0" multiple locale="ru-ru">
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click="filter.modalOpen = false">Ok</v-btn>
              <v-btn color="red darken-1" flat @click="clearDateFilter()">Сбросить</v-btn>
              <v-spacer></v-spacer>
            </v-date-picker>
          </v-dialog>
        </v-form>
      </v-flex>
    </v-container>
  </div>
</template>

<script>

import Moment from "moment";
import { extendMoment } from "moment-range";

const moment = extendMoment(Moment);

export default {
  components: {
    Moment
  },
  data() {
    return {
      disableBtnSave: true, // флаг ожидания ApiKey при выборе staff
      selectedReport: {
        id: null,
        key: null
      },
      valid: true,
      rules: {
        required: value => !!value || "Поле не может быть пустым.",
        dateEmpty: v => v !== "—" || "Нужно выбрать период"
      },
      filter: {
        name: "Период",
        key: "created",
        sortOrder: 2,
        items: [],
        comment: "",
        hidden: false,
        value: {
          start: this.getDate(-30), // js ф-ия из начала файла
          end: this.getDate(),
          range: []
        },
        dependency: {},
        class: "",
        icon: "date_range",
        modalOpen: false
      },
      poh2022: false,
    };
  },

  computed: {
    /**
     * Список отчетов
     */
    reportList() {
      return this.$store.getters["report/reportData"]
        .map(x => ({
          text: x.nameReport,
          value: x.id,
          url: x.urlReport,
          defaultParams: x.defaultParams
        }));
    },

    /**
     * Список пользователей
     */
    accountList() {
      return this.$store.getters["account/accountData"];
    },

    /**
     * Список ставок
     */
    staffList() {
      return this.$store.getters["staff/staffData"];
    },

    /**
     * Данные Лога
     * @returns {default.computed.logData|(function())|Array|getters.logData}
     */
    logData() {
      return this.$store.getters["log/logData"];
    },

    /**
     * Список менеджер для select
     * @returns {*}
     */
    staffListForSelect() {
      let result = [];

      this.staffList.forEach(st => {
        let accountByStaffExtId = !!st && !!st.extId && this.accountList.find(acc => !!acc.extId && acc.extId === st.extId && acc.isActive);

        if (accountByStaffExtId) {
          result.push({
            text: `${accountByStaffExtId.fullname} (${st.pgName})`,
            value: st.id
          });
        }
      });

      return result;
    },

    dateRange: {
      get: function () {
        let dateRange = [],
          drFilter = this.filter.value;

        if (drFilter.start !== "" && drFilter.end !== "") {
          let range = moment.range(drFilter.start, drFilter.end);

          for (let day of range.by("day")) {
            dateRange.push(day.format("YYYY-MM-DD"));
          }
        }

        drFilter.range = dateRange;

        return drFilter.range;
      },

      set: function (val) {
        let dateRange = [],
          drFilter = this.filter.value;

        if (drFilter.start !== "" && drFilter.end !== "") {
          if (!_.isEmpty(val)) {
            let _val = _.last(val),
              range = moment.range(drFilter.start, drFilter.end);

            if (range.contains(_val)) {
              drFilter.start = _val;
            } else {
              if (moment(_val) < moment(drFilter.start)) {
                drFilter.start = _val;
              } else if (moment(_val) > moment(drFilter.end)) {
                drFilter.end = _val;
              }
            }

            range = moment.range(drFilter.start, drFilter.end);

            for (let day of range.by("day")) {
              dateRange.push(day.format("YYYY-MM-DD"));
            }
          }
        } else {
          drFilter.start = _.head(val);
          drFilter.end = _.last(val);
        }

        drFilter.range = dateRange;

        return drFilter.range;
      }
    }
  },

  mounted: function () {
    /**
     * Обновляем данные при каждом открытии вкладки
     */
    this.refresh();

    /**
     * Загружаем данные о сотрудниках и отчётах
     */
    if (this.reportList.length === 0 || this.accountList.length === 0 || this.staffList.length === 0 || this.staffListForSelect.length === 0) {
      this.refresh();
    }
  },

  methods: {
    /**
     * Обновление данных по ролям
     */
    refresh() {
      this.$store._actions["staff/getStaffData"][0]();
      this.$store._actions["account/getAccountData"][0]();
      this.$store._actions["report/getReportData"][0]();
    },

    /**
     * Выбор сотрудника из списка
     * @param value
     */
    changeStaff(value) {
      this.disableBtnSave = true;

      let selectedStaff = this.staffList.find(st => st.id === value),
        accountByStaffExtId = this.accountList.find(acc => !!selectedStaff && acc.extId === selectedStaff.extId);

      if (!accountByStaffExtId) return;

      this.$store._actions["report/getApiKeyData"][0]({ staffUsername: accountByStaffExtId.username })
        .then(() => {
          this.selectedReport.key = this.$store.getters["report/apiKeyData"][0].apiKey;
          this.disableBtnSave = false;
        });
    },

    /**
     * Выбор отчёта из списка
     * @param value
     */
    changeReport(value) {
      this.selectedReport.id = value;
    },

    /**
     * Получить параметры запроса
     * @param {string} defaultParams
     */
    getURLSearchParams(defaultParams) {
      const searchParams = `?apiKey=${this.selectedReport.key}&from=${this.filter.value.start}&to=${this.filter.value.end}`;
      return searchParams + defaultParams + (this.poh2022 ? '&dataSource=poh_2022' : '');
    },

    /**
     * Получить URL сервиса отчёта
     * @param {{text: string, value: number, url: string, defaultParams: string}} report Отчёт
     * @return {string} URL сервиса отчёта
     */
    getReportServiceURL(report) {
      return this.$store.state.netUrl + report.url + this.getURLSearchParams(report.defaultParams);
    },

    getReport() {
      if (!this.$refs.formTemplate.validate()) return;

      const selectedReport = this.reportList.find(x => x.value === this.selectedReport.id);

      if (!selectedReport) return;

      window.open(
        this.getReportServiceURL(selectedReport),
        "_blank"
      );
    },

    clearDateFilter() {
      this.filter.value = {
        start: "",
        end: "",
        range: [],
      };
    },

    getDate(days) {
      let today = new Date();

      if (days !== null && typeof days !== "undefined") {
        today = new Date(today.setDate(today.getDate() + days));
      }

      let dd = today.getDate(),
        mm = today.getMonth() + 1;

      if (dd < 10) {
        dd = `0${dd}`;
      }

      if (mm < 10) {
        mm = `0${mm}`;
      }

      return `${today.getFullYear()}-${mm}-${dd}`;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/ui/Reports.vue